'use client';

import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { CartItemFragment } from '@/fo/api/magento';
import { UiKitModalBase } from '@/fo/ui/kit/modal/base';
import { UiKitPriceBase } from '@/fo/ui/kit/price/base';
import { UiLoyaltyLabelBase } from '@/fo/ui/loyalty/label/base';

import { styles } from './CheckoutItemsModal.styles';

/** Поля product из GraphQL, не раскрытые типом фрагмента CartItem */
interface ProductDisplay {
  image?: { src?: string } | null;
  name?: string | null;
}

export interface CheckoutItemsModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  products: CartItemFragment[];
}

// По большей части перенесено из https://git.oggettoweb.com/dreame/react/-/blob/main_08_04/packages/libs/fo/feature/checkout/stepper/base/src/components/OrderDetailModal/OrderDetailModal.tsx
export function CheckoutItemsModal({
  isOpen,
  setIsOpen,
  products
}: CheckoutItemsModalProps) {
  const slots = styles();
  const t = useTranslations();
  return (
    <UiKitModalBase
      title={t('orders.products')}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      className={slots.base()}
    >
      <div className={slots.list()}>
        {products.map((item) => {
          const product = item.product as ProductDisplay | null | undefined;
          return (
            <div
              key={item.id}
              className={slots.productItem()}
            >
              <div className={slots.productImage()}>
                <Image
                  src={product?.image?.src ?? ''}
                  alt={product?.name ?? ''}
                  width={100}
                  height={100}
                />
              </div>
              <div className={slots.productInfo()}>
                <div className={slots.productInfoLeft()}>
                  <p className={slots.productName()}>{product?.name}</p>
                  <p className={slots.productCount()}>
                    {item.quantity} {t('product.inStock.units')}
                  </p>
                </div>

                <div className={slots.productInfoRight()}>
                  <UiKitPriceBase
                    value={item.prices?.price?.value ?? 0}
                    currency={item.prices?.price?.currency ?? undefined}
                    className={slots.productPrice()}
                  />
                  {(item.mindbox_earned_bonus_amount ?? 0) > 0 && (
                    <UiLoyaltyLabelBase
                      points={item.mindbox_earned_bonus_amount ?? 0}
                    />
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </UiKitModalBase>
  );
}
